import React, { useEffect } from 'react';
// TODO: Null checks and tests

import ResponsiveImage from './ResponsiveImage';

import 'objectFitPolyfill';

import { BackgroundImageContainer, BackgroundImageWrapper } from './BackgroundImage.styled';

const BackgroundImage = ({ mobile, tablet, tabletLarge, desktop, alt }) => {
  useEffect(() => {
    window.objectFitPolyfill();
  }, []);

  return (
    <BackgroundImageContainer>
      <BackgroundImageWrapper>
        <ResponsiveImage
          mobile={mobile}
          tablet={tablet}
          tabletLarge={tabletLarge}
          desktop={desktop}
          alt={alt}
          data-object-fit
        />
      </BackgroundImageWrapper>
    </BackgroundImageContainer>
  );
};

export default BackgroundImage;
